import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdTimelineOptions } from '@onefootprint/fetch-dashboard';
import type { UserTimeline, UserTimelineEventDeviceInsight, UserTimelineEventDeviceVisit } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
type DeviceInsightEvent = UserTimeline & {
  event: UserTimelineEventDeviceInsight;
};
type DeviceVisitEvent = UserTimeline & {
  event: UserTimelineEventDeviceVisit;
};
const isDeviceEvent = (event: UserTimeline): event is DeviceInsightEvent | DeviceVisitEvent => {
  return event.event.kind === 'device_insight' || event.event.kind === 'device_visit';
};
const isDeviceVisit = (event: DeviceInsightEvent | DeviceVisitEvent): event is DeviceVisitEvent => {
  return event.event.kind === 'device_visit';
};
const useEntityDeviceInsights = (entityId, asOf) => {
  const $ = _c(7);
  let t0;
  if ($[0] !== entityId) {
    t0 = getEntitiesByFpIdTimelineOptions({
      path: {
        fpId: entityId
      },
      query: {
        kinds: "device_insight,device_visit",
        pageSize: 100
      }
    });
    $[0] = entityId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== asOf) {
    t1 = data => ({
      ...data,
      data: data.data.filter(isDeviceEvent).filter(e => !asOf || new Date(e.timestamp) <= new Date(asOf))
    });
    $[2] = asOf;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      ...t0,
      select: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
export type { DeviceInsightEvent, DeviceVisitEvent };
export { isDeviceVisit };
export default useEntityDeviceInsights;